import { render, staticRenderFns } from "./PromoBar.vue?vue&type=template&id=a8c3f6ea&scoped=true&"
import script from "./PromoBar.vue?vue&type=script&lang=js&"
export * from "./PromoBar.vue?vue&type=script&lang=js&"
import style0 from "./PromoBar.vue?vue&type=style&index=0&id=a8c3f6ea&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c3f6ea",
  null
  
)

export default component.exports